module.exports = __webpack_public_path__ + "static/media/berries.d02d77b8.jpeg";